export default __webpack_public_path__ + "static/Dashly-5acf29314f693bd7ff7bf7a6b4bab3a4.png";